var Media = function () {

    function init() {

        // if there's a content id in the URI, open the video layer on document.ready
        var mediaId = Util.getParameter("content");

        if (jQuery.isNumeric(mediaId)) {

          load(mediaId);

        }

    }

    function load(mediaId, src, type) {

        if (mediaId) {

            if (type && type == 'audio') {

                nisp.fetchSound(mediaId, src);

            }

            else {

                var mediaLink = jQuery("a.media[data-content=" + mediaId + "]");
                if (mediaLink.length > 0) {
                    // content link is on the page: just simulate a click
                    mediaLink.first().click();
                    if (Util.isAppleMobileDevice()) {
                        // autoplay doesn't work on iOS devices
                        if (typeof nisp !== "undefined") {
                            nisp.iOsAutoplayFallback();
                        }
                    }

                } else {

                    // content not on page, trigger ajax request
                    jQuery.get(
                        "/", {
                            eID: "extbase",
                            extensionName: "NiMedia",
                            pluginName: "nimedia",
                            controllerName: "Media",
                            actionName: "ajax",
                            media: mediaId
                        }, function (data) {
                            var response = jQuery.parseJSON(data);
                            response = response.data;
                            if (response.mediaType == "audio" && typeof nisp !== "undefined") {
                                nisp.fetchSound(response.itemId, src);
                                 if (Util.isAppleMobileDevice()) {
                                    // autoplay doesn't work on iOS devices
                                    nisp.iOsAutoplayFallback();
                                }
                            } else if (response.mediaType == "youtube") {
                                // TODO: re-use existing popup definition
                                jQuery.magnificPopup.open({
                                    items: {
                                        src: "//www.youtube.com/embed/"
                                            + response.chapters[0].videoId
                                            + "?showinfo=1&rel=0&hd=1&cc_lang_pref=en&cc_load_policy=1"
                                            + (response.chapters[0].playlistLinkPart ? response.chapters[0].playlistLinkPart : '')
                                    },
                                    type: 'iframe',
                                    closeBtnInside: true,
                                    removalDelay: 300,
                                    mainClass: 'mfp-fade',
                                    iframe: {
                                        patterns: {
                                            youtube: {
                                                index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).
                                                id: function (url) {
                                                    return url;
                                                },
                                                src: '%id%&autoplay=0' // URL that will be set as a source for iframe.
                                            }
                                        }
                                    }
                                });
                            }
                        }
                    );
                }

            }

        }

    }

    function close() {

        if (typeof nisp !== "magnificPopup") {
            magnificPopup.close();
        }

        if (typeof nisp !== "undefined") {
            nisp.hidePlayer();
        }

    }

    function refresh(mediaId, src, type) {

        if (type == 'youtube') {
            close();
        }

        load(mediaId, src, type);

    }

    // public methods

    return {

        init: init,
        load: load,
        refresh: refresh,
        close: close

    }

}();
